"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Grid = ({ colour = "#E6E6E6", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, stroke: colour },
    react_1.default.createElement("path", { fill: "none", d: "M5 2v12m6-12v12M1 10h14M1 6h14v0M1 2h14v12H1z" })));
exports.Grid = Grid;
//# sourceMappingURL=Grid.js.map